<div id="faq" class="page-layout simple full-width">

    <!-- HEADER -->
    <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">
        <div class="hero-text mb-16">
            <h1>Opciones Inteligencia Artifical
                <span> 
                    <mat-icon>memory</mat-icon>
                </span>
            </h1>
        </div>
    </div>
    <div class="flexContainer" *ngIf="!muestraPrompt && !muestraTipificaciones && !muestraVoces && !muestraSaludo && !muestraObjetivos && !muestraEmail  && !muestraDiscador && !muestraSms && !muestraOpcionesSms">
        <mat-card class="card">
            <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>Saludo</mat-card-title>
                <mat-card-subtitle>Da la bienvenida a tus usuarios</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content>
              <p>Personaliza tu propio Saludo inicial.</p>
              <p></p>
              <br>
              <button mat-raised-button (click)="mostrarSaludo()" class="cta-button atBottom" color="accent">
                Saludo
            </button>
            </mat-card-content>
        </mat-card>
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>Generador IA</mat-card-title>
              <mat-card-subtitle>Parámetros IA</mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content>
            <p>Proporciona la finalidad  de tu proyecto a nuestra IA.</p>
            <p>Cuéntanos quien eres y que necesitas</p>
            <br>
            <button mat-raised-button  (click)="mostrarPrompt()" class="cta-button atBottom" color="accent">
              Generador IA
          </button>
          </mat-card-content>
      </mat-card>
        <mat-card class="card">
            <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>Tipificaciones</mat-card-title>
                <mat-card-subtitle>Clasificación llamadas</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content>
              <p>Especifícanos que tipificaciones buscas en tus llamadas.</p>
              <p></p>
              <br>
              <button mat-raised-button (click)="mostrarTipificaciones()" class="cta-button atBottom" color="accent">
                Tipificaciones
              </button>
            </mat-card-content>
        </mat-card>
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>Resultados</mat-card-title>
              <mat-card-subtitle>Objetivos</mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content>
            <p>Especifícanos que objetivos buscas en términos simples.</p>
            <p></p>
            <br>
            <button mat-raised-button (click)="mostrarObjetivos()" class="cta-button atBottom" color="accent">
              Resultados
            </button>
          </mat-card-content>
      </mat-card>


        <mat-card class="card">
          <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>Envío Sms</mat-card-title>
              <mat-card-subtitle>Opciones SMS</mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content>
            <p>Configura si quieres recibir notificaciones por SMS de las llamadas</p>
            <p></p>
            <br>
            <button mat-raised-button (click)="mostrarSms()" class="cta-button atBottom" color="accent">
              Configurar
            </button>
          </mat-card-content>
       </mat-card>

       <mat-card class="card">
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>Envío Email</mat-card-title>
            <mat-card-subtitle>Opciones Email</mat-card-subtitle>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content>
          <p>Configura si quieres recibir notificaciones por Email de las llamadas</p>
          <p></p>
          <br>
          <button mat-raised-button (click)="mostrarEmail()" class="cta-button atBottom" color="accent">
            Configurar
          </button>
        </mat-card-content>
     </mat-card>


     <mat-card class="card">
      <mat-card-header>
        <mat-card-title-group>
          <mat-card-title>Voces</mat-card-title>
          <mat-card-subtitle>Locutores</mat-card-subtitle>
        </mat-card-title-group>
      </mat-card-header>
      <mat-card-content>
        <p>Elige que voz te gustaría ser tu agente virtual.</p>
        <p></p>
        <br>
        <button mat-raised-button (click)="mostrarVoces()" class="cta-button atBottom" color="accent">
          Voces
        </button>
      </mat-card-content>
  </mat-card>

      <mat-card class="card">
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>Discador</mat-card-title>
            <mat-card-subtitle>Lanzar Campaña</mat-card-subtitle>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content>
          <p>Desde aquí puedes iniciar o parar tu campaña de llamadas.</p>
          <p></p>
          <br>
          <button mat-raised-button (click)="mostrarDiscador()" class="cta-button atBottom" color="accent">
            Configurar
          </button>
        </mat-card-content>
      </mat-card>
       
    </div>
    <!--  /////////////////////////////////////-->
   
    <div *ngIf="muestraVoces" class="flexContainer">
      <mat-card class="leadForm" style="width: 60%;">
            <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>VOCES</mat-card-title>
              <mat-card-subtitle>Locutor para tu IA</mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
            <mat-form-field>
                <mat-label>Elige una Voz</mat-label>
                <mat-select [(value)]="vozActual">
                  <mat-option value="es-ES-Neural2-E">Premium Femenino E</mat-option>
                  <mat-option value="es-ES-Neural2-F">Premium Masculino F</mat-option>
                  <mat-option value="es-ES-Wavenet-B">Wave Masculino B</mat-option>
                  <mat-option value="es-ES-Wavenet-C">Wave Femenino C</mat-option>
                  <mat-option value="es-ES-Wavenet-D">Wave Femenino D</mat-option>
                  <mat-option value="es-ES-Wavenet-E">Wave Masculino E</mat-option>
                  <mat-option value="es-ES-Wavenet-F">Wave Femenino F</mat-option>
                  <mat-option value="es-ES-Journey-D">Journey Masculino D</mat-option>
                  <mat-option value="es-ES-Journey-F">Journey Femenino F</mat-option>
                  <mat-option value="ca-es-Standard-A">Cat Femenino 1</mat-option>
                  <mat-option value="ca-ES-Standard-B">Cat Femenino 2</mat-option>
                </mat-select>
              
              </mat-form-field>
              <!--
                    <mat-label>Introduce texto para probar tu voz</mat-label>
                    <textarea id="textoIa"
                              rows="1"
                              style="width:90%; max-width: 90%; resize: none;">
                    </textarea>
                  -->
                    <div class="atBottom">
                          <!--<button mat-raised-button (click)="makeVoice()" class="cta-button" style="margin-left: 10px;"  color="accent" [disabled]="loading">
                            {{ textoBoton }}
                          </button>-->
                          <button mat-raised-button (click)="saveVoice()" class="cta-button" style="margin-left: 10px;"  color="accent" [disabled]="loading">
                            Asignar Voz
                          </button>
                          <button mat-raised-button (click)="muestraVoces = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                            Cerrar
                          </button>
                  </div>
                  <!--<audio id="miaudio" src=""></audio>-->
          </mat-card-content>
            
        </mat-card>
    </div>

     <div *ngIf="showPass" class="flexContainer">
      <mat-card class="leadForm" style="width: 60%;">
          <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>ACCESO RESTRINGIDO</mat-card-title>
            <mat-card-subtitle>Introduzca contraseña de Administrador</mat-card-subtitle>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
                  <mat-label>Contraseña</mat-label>
                  <mat-form-field appearance="outline" style="margin-right: 20px; width: 80%;">
                    <input id="unlockPass" matInput  type="password" placeholder="Contraseña">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                  </mat-form-field>
           
                  <div class="atBottom">
                        <button mat-raised-button (click)="showUnlock()" class="cta-button" style="margin-left: 10px;"  color="accent">
                         Aceptar
                        </button>
                        <button mat-raised-button (click)="showPass = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                          Cancelar
                        </button>
                </div>
        </mat-card-content>
        
      </mat-card>
      </div>

      <div *ngIf="muestraPrompt && (globalService.campaignAivoz.tipo === 3)" class="flexContainer">
          
        <mat-card class="leadForm" style="width: 60%;">
            <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>Configura tu IA</mat-card-title>
              <mat-card-subtitle>Plantilla: Atención Cliente y Transferencia Llamadas</mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
         

          <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
            <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

              <label for="plantilla">Cambiar Plantilla</label><br>
              <select id="plantilla" (change)="cambiaPlantilla()" [(ngModel)]="tipoPlantilla">
                <option *ngFor="let plantilla of plantillas; let i = index"  [selected]="tipoPlantilla == (i+1)" [value]="(i+1)">{{ plantilla }}</option>
              </select>
              <div style="float: right;">
                <button mat-raised-button (click)="makePlantilla()" class="cta-button" style="margin-left: 10px;"  color="accent">
                  Cambiar Plantilla
                </button>
              </div>
              </div>
            <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                    <mat-label>¿ Cómo se llama y a que se dedica tu empresa ?</mat-label><br>
                    <mat-label>(Ejemplo: "Alquileres García, Alquiler vacacional, buscamos viviendas para gestionarlas")</mat-label><br><br>

                    <textarea id="datos1"
                              rows="4"
                              style="width:90%; max-width: 90%; border-radius: 7px;">
                    </textarea>
            </div>
            
                    <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                    <mat-label><strong>Descripción de los departamentos</strong></mat-label><br>
                    <mat-label>Ejemplo:<br>1.	El departamento de reservas recibe llamadas de personas que no tienen reservas y quieren hacer una reserva o modificar una existente.<br>
                      2.	El departamento de check-in se encarga de llamadas de clientes con reservas que desean hacer el check-in.</mat-label><br><br>
                    <textarea id="datos2"
                              rows="6"
                              style="width:90%; max-width: 90%; border-radius: 7px;">
                    </textarea> 
                  </div>
                  <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">
                    <mat-label><strong>Especificación de traspasos</strong></mat-label><br>
                    <mat-label>Ejemplo:
                      <br>El departamento de reservas es el numero 0034111111111
                      <br>El departamento de check-in es el numero 0034222222222
                     </mat-label><br><br>
                    <textarea id="datos3"
                              rows="4"
                              style="width:90%; max-width: 90%; border-radius: 7px;">
                    </textarea>
                  </div>
                  <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">
                    <mat-label><strong>Otros supuestos no contemplados</strong></mat-label><br>
                    <mat-label>Ejemplo:
                      <br>Si el usuario no decide departamento despidete.
                      <br>Si no hay ningun departamento adecuado deriva al departamento de ventas o al número 123456789.
                     </mat-label><br><br>
                    <textarea id="datos4"
                              rows="4"
                              style="width:90%; max-width: 90%; border-radius: 7px;">
                    </textarea>
                  </div>
                    <br><br><br><br>
                    <div class="atBottom">
                          <button mat-raised-button (click)="makePrompt()" class="cta-button" style="margin-left: 10px;"  color="accent">
                            Generar IA
                          </button>
                          <button mat-raised-button (click)="muestraPrompt = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                            Cerrar
                          </button>
                  </div>
          </mat-card-content>
          
        </mat-card>
      </div>

        <div *ngIf="muestraPrompt && globalService.campaignAivoz.tipo === 2" class="flexContainer">
          
            <mat-card class="leadForm" style="width: 60%;">
                <mat-card-header>
                <mat-card-title-group>
                  <mat-card-title>Configura tu IA</mat-card-title>
                  <mat-card-subtitle>Plantilla: Gestión de Citas</mat-card-subtitle>
                </mat-card-title-group>
              </mat-card-header>
             
              <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
                <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">
                  <label for="plantilla">Cambiar Plantilla</label><br>
                  <select id="plantilla" (change)="cambiaPlantilla()" [(ngModel)]="tipoPlantilla">
                    <option *ngFor="let plantilla of plantillas; let i = index"  [selected]="tipoPlantilla == (i+1)" [value]="(i+1)">{{ plantilla }}</option>
                  </select>
                  <div style="float: right;">
                    <button mat-raised-button (click)="makePlantilla()" class="cta-button" style="margin-left: 10px;"  color="accent">
                      Cambiar Plantilla
                    </button>
                  </div>
                </div>    
                <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                       <mat-label><strong>Describe que tiene q saber el asistente de tu empresa</strong></mat-label><br>
                       <mat-label>(Ejemplo: "Somos un campo de Golf...")</mat-label><br><br>
                       <textarea id="datos1"
                       rows="2"
                       style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea>
                    </div>
                    <br>
                    <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label><strong>Descríbenos tu negocio</strong></mat-label><br>
                      <mat-label>(Ejemplo: "Es un campo de Golf para los socios")</mat-label><br><br>
                      <textarea id="datos2"
                      rows="2"
                      style="width:90%; max-width: 90%;  border-radius: 7px;">
                     </textarea>
                   </div>
                   <br>
                   <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">
                        <mat-label><strong>Dias apertura de la semana</strong></mat-label><br>
                        <mat-label>Indícanos que dias está disponbible tu negocio</mat-label><br><br>
                        <div style="display: flex; flex-direction:row; column-count: 7;">
                          L <input style="margin: 5px" id="d1" type="checkbox"/>
                          M <input style="margin: 5px" id="d2" type="checkbox"/>
                          X <input style="margin: 5px" id="d3" type="checkbox"/>
                          J <input style="margin: 5px" id="d4" type="checkbox"/>
                          V <input style="margin: 5px" id="d5" type="checkbox"/>
                          S <input style="margin: 5px" id="d6" type="checkbox"/>
                          D <input style="margin: 5px" id="d0" type="checkbox"/>
                        </div>
                      </div>

                      <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                        <mat-label><strong>Inicio y final del Servicio prestado diariamente</strong></mat-label><br>
                        <mat-label>(Hora inicio y final de la jornada)</mat-label><br>
                        <div style="display: flex; flex-direction:row; column-count: 2;">
                          Inicio <input style="margin: 3px" id="inicio" type="time"/>
                          Final <input style="margin: 3px" id="fin" type="time"/>
                        </div>
                        <br>
                      </div>
                      <br>
                    <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                        <mat-label><strong>Intervalo Citas</strong></mat-label><br>
                        <mat-label>(Duración de cada cita en minutos)</mat-label><br>
                        <div style="display: flex; flex-direction:row; column-count: 2;">
                          Intervalo <input style="margin: 3px" id="intervalo" type="number"/> minutos
                        </div>
                    </div>
                        <br><br><br><br>
                        <div class="atBottom">
                              <button mat-raised-button (click)="makePrompt()" class="cta-button" style="margin-left: 10px;"  color="accent">
                                Generar IA
                              </button>
                              <button mat-raised-button (click)="muestraPrompt = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                                Cerrar
                              </button>
                      </div>
              </mat-card-content>
              
            </mat-card>
        </div>

        <div *ngIf="muestraPrompt && (globalService.campaignAivoz.tipo === 1)" class="flexContainer">
          
          <mat-card class="leadForm" style="width: 60%;">
              <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>Configura tu IA</mat-card-title>
                <mat-card-subtitle>Plantilla: Encuestas</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
           

            <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
              <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                <label for="plantilla">Cambiar Plantilla</label><br>
                <select id="plantilla" (change)="cambiaPlantilla()" [(ngModel)]="tipoPlantilla">
                  <option *ngFor="let plantilla of plantillas; let i = index"  [selected]="tipoPlantilla == (i+1)" [value]="(i+1)">{{ plantilla }}</option>
                </select>
                <div style="float: right;">
                  <button mat-raised-button (click)="makePlantilla()" class="cta-button" style="margin-left: 10px;"  color="accent">
                    Cambiar Plantilla
                  </button>
                </div>
                </div>
              <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label><strong>¿A que se dedica tu negocio y para qué es la encuesta?</strong></mat-label><br>
                      <mat-label>(Ejemplo: "Eres una inmobiliaria y quieres saber el grado de satisfacción de los clientes")</mat-label><br><br>

                      <textarea id="datos1"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea>
              </div>
            
                      <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label>Tipo de calificación</mat-label><br>
                      <mat-label><strong>(Ejemplo: "Califica las respuestas del 1 al 10 siendo 1 muy descontendo y 10 muy contento")</strong></mat-label><br><br>
                      <textarea id="datos2"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea> 
                    </div>
               <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label><strong>Preguntas de la encuesta</strong></mat-label><br>
                      <mat-label>(Ejemplo: "1- ¿ Esta contento con nuestro servicio ?, 2-"Nuestros agentes, han cumplido su espectativa, 3..)</mat-label><br><br>
                      <textarea id="datos3"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea>
                  </div>
                  <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                    <mat-label><strong>Información Adicional</strong></mat-label><br>
                      <mat-label>(Ejemplo: "La encuesta va dirigida a personas de más de 40 años.")</mat-label><br><br>
                    <textarea id="datos4"
                              rows="4"
                              style="width:90%; max-width: 90%; border-radius: 7px;">
                    </textarea>
            </div>
                      <br><br><br><br>
                      <div class="atBottom">
                            <button mat-raised-button (click)="makePrompt()" class="cta-button" style="margin-left: 10px;"  color="accent">
                              Generar IA
                            </button>
                            <button mat-raised-button (click)="muestraPrompt = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                              Cerrar
                            </button>
                    </div>
            </mat-card-content>
            
          </mat-card>
        </div>

        <div *ngIf="muestraPrompt && (globalService.campaignAivoz.tipo === 4)" class="flexContainer">
          
          <mat-card class="leadForm" style="width: 60%;">
              <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>Configura tu IA</mat-card-title>
                <mat-card-subtitle>Plantilla: Atención Telefónica</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
           

            <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
              <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                <label for="plantilla">Cambiar Plantilla</label><br>
                <select id="plantilla" (change)="cambiaPlantilla()" [(ngModel)]="tipoPlantilla">
                  <option *ngFor="let plantilla of plantillas; let i = index"  [selected]="tipoPlantilla == (i+1)" [value]="(i+1)">{{ plantilla }}</option>
                </select>
                <div style="float: right;">
                  <button mat-raised-button (click)="makePlantilla()" class="cta-button" style="margin-left: 10px;"  color="accent">
                    Cambiar Plantilla
                  </button>
                </div>
                </div>
              <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label><strong>¿Qué necesitas que sea el agente conversacional?</strong></mat-label><br>
                      <mat-label>(Ejemplo: "Eres un experto vendedor de seguros")</mat-label><br><br>

                      <textarea id="datos1"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea>
              </div>
              <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label><strong>¿Qué necesitas que haga el agente conversacional?</strong></mat-label><br>
                        <mat-label>(Ejemplo: "Proveer información sobre trámites de pasaportes)"</mat-label><br><br>
                      <textarea id="datos2"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea>
                  </div>
                      <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label>¿Quién es el usuario al que irá dirigido esta conversación?</mat-label><br>
                      <mat-label><strong>(Ejemplo: "Una persona que nunca ha hecho un trámite de pasaporte.")</strong></mat-label><br><br>
                      <textarea id="datos3"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea> 
                    </div>
               <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label><strong>¿Qué información debe conocer el agente para responder correctamente?</strong></mat-label><br>
                      <mat-label>(Ejemplo: "De qué país es originario, edad, etc...")</mat-label><br><br>
                      <textarea id="datos4"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea>
                  </div>
                      <br><br><br><br>
                      <div class="atBottom">
                            <button mat-raised-button (click)="makePrompt()" class="cta-button" style="margin-left: 10px;"  color="accent">
                              Generar IA
                            </button>
                            <button mat-raised-button (click)="muestraPrompt = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                              Cerrar
                            </button>
                    </div>
            </mat-card-content>
            
          </mat-card>
        </div>

        <div *ngIf="muestraPrompt && (globalService.campaignAivoz.tipo === 5)" class="flexContainer">
          
          <mat-card class="leadForm" style="width: 60%;">
              <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>Configura tu IA</mat-card-title>
                <mat-card-subtitle>Plantilla: Asistente a Mayores</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
           

            <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
              <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                <label for="plantilla">Cambiar Plantilla</label><br>
                <select id="plantilla" (change)="cambiaPlantilla()" [(ngModel)]="tipoPlantilla">
                  <option *ngFor="let plantilla of plantillas; let i = index"  [selected]="tipoPlantilla == (i+1)" [value]="(i+1)">{{ plantilla }}</option>
                </select>
                <div style="float: right;">
                  <button mat-raised-button (click)="makePlantilla()" class="cta-button" style="margin-left: 10px;"  color="accent">
                    Cambiar Plantilla
                  </button>
                </div>
                </div>
              <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label><strong>Datos de la persona a cuidar y datos identificativos</strong></mat-label><br>
                      <mat-label>(Ejemplo: "Se llama Juan y tiene 80 años, tiene 3 hijos que son ...( dar la máxima información posible )")</mat-label><br><br>

                      <textarea id="datos1"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea>
              </div>
              <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label><strong>Recordatorios de Medicamentos y Cuidados</strong></mat-label><br>
                        <mat-label>(Ejemplo: "Proveer información de su salud, si necesita medicación, cuáles son y especificaciones, limitaciones físicas, etc )"</mat-label><br><br>
                      <textarea id="datos2"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea>
                  </div>
                      <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label>Conversaciones Agradables</mat-label><br>
                      <mat-label><strong>(Ejemplo: "Temas favoritos que le hacen sentir bien. Anécdotas de su pasado, peliculas y canciones favoritas y cualquier situación que le agrade.")</strong></mat-label><br><br>
                      <textarea id="datos3"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea> 
                    </div>
               <div style="border: 1px solid lightgray; padding: 10px; border-radius: 7px; width: 90%;">

                      <mat-label><strong>¿De que no se debe hablar nunca con esta persona? ¿Qué situaciones o comportamientos les molesta?</strong></mat-label><br>
                      <mat-label>(Ejemplo: "Qué cosas le molestan, evita o le ponen de mal humor. Conversaciones a evitar.")</mat-label><br><br>
                      <textarea id="datos4"
                                rows="4"
                                style="width:90%; max-width: 90%; border-radius: 7px;">
                      </textarea>
                  </div>
                      <br><br><br><br>
                      <div class="atBottom">
                            <button mat-raised-button (click)="makePrompt()" class="cta-button" style="margin-left: 10px;"  color="accent">
                              Generar IA
                            </button>
                            <button mat-raised-button (click)="muestraPrompt = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                              Cerrar
                            </button>
                    </div>
            </mat-card-content>
            
          </mat-card>
        </div>

        <div *ngIf="muestraDiscador" class="flexContainer">
          <mat-card class="leadForm" style="width: 60%;">
              <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>DISCADOR</mat-card-title>
                <mat-card-subtitle>Lanzamiento campaña</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content class="flexContainer" style="flex-direction: column; height: auto; text-align: left;">
                      <mat-label>Estado Discador</mat-label>
                      <mat-label *ngIf="globalService.discador"><strong>{{ globalService.discador.estado === 1 ? 'ACTIVADO' : 'DESACTIVADO'}}</strong></mat-label>
                      <mat-label *ngIf="!globalService.discador"><strong>DISCADOR NO DISPONIBLE</strong></mat-label>
                      <mat-label>Leads cargados: {{ numeroLeads }}</mat-label>
                      <mat-label>Leads Procesados: {{ leadsProcesados }}</mat-label>
                      <mat-label>Leads Pendientes: {{ leadsPendientes }}</mat-label>
                      <br><br><br>
                      <div class="atBottom">
                        <button *ngIf="existDiscador && !discadorActivo" mat-raised-button (click)="fileInput.click()" class="cta-button" color="accent">
                          Carga Modelo CSV
                        </button>
                         
                          <input hidden (change)="obtenerDatos($event.target)" formControlName="archivo"  #fileInput type="file" id="file"
                              required>
                              <button *ngIf="discadorActivo && existDiscador" mat-raised-button (click)="mostrarDiscador()" class="cta-button" style="margin-left: 10px;"  color="accent">
                                Refrescar
                              </button>
                            <button *ngIf="!discadorActivo && existDiscador" mat-raised-button (click)="discador(1)" class="cta-button" style="margin-left: 10px;"  color="accent">
                              Iniciar
                            </button>
                            <button *ngIf="discadorActivo && existDiscador" mat-raised-button (click)="discador(0);" class="cta-button" style="margin-left: 10px; background-color: rgb(195, 157, 82); color: black;" color="accent">
                              Parar
                            </button>
                            <button mat-raised-button (click)="muestraDiscador = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                              Cerrar
                            </button>
                    </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div *ngIf="muestraSaludo" class="flexContainer">
          <mat-card class="leadForm" style="width: 60%;">
              <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>NUEVO SALUDO</mat-card-title>
                <mat-card-subtitle>Saludo</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
                      <mat-label>Introduzca Saludo inicial</mat-label>
                      <textarea id="saludo"
                                rows="5"
                                style="width:90%; max-width: 90%; resize: none;">
                      </textarea>
               
                      <div class="atBottom">
                            <button mat-raised-button (click)="makeSaludo()" class="cta-button" style="margin-left: 10px;"  color="accent">
                              Actualizar Saludo
                            </button>
                            <button mat-raised-button (click)="muestraSaludo = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                              Cerrar
                            </button>
                    </div>
            </mat-card-content>
            
          </mat-card>
        </div>

        <div *ngIf="muestraOpcionesSms" class="flexContainer">
          <mat-card class="leadForm" style="width: 80%;">
              <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>SMS Tipificación</mat-card-title>
                <mat-card-subtitle>Opciones</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
                        <mat-label><strong>Activar envío SMS</strong><span><input id="enviarSms" type="checkbox"  style="margin-left: 5px;" (click)="clickEnviar()"></span></mat-label>
                        <label for="tipoSms" *ngIf="tipificacionActual.enviarSms"><strong>Tipo Envío</strong></label>
                        <select id="tipoSms" *ngIf="tipificacionActual.enviarSms" (change)="cambiaTipoSms()">
                          <option [selected]="tipificacionActual.sameSms" [value]= "true">Enviar a Usuario</option>
                          <option [selected]="!tipificacionActual.sameSms" [value]= "false">Enviar a Número</option>
                        </select>
                        <mat-label *ngIf="tipificacionActual.enviarSms && !tipificacionActual.sameSms"><strong>Enviar SMS al número</strong> </mat-label>
                        <input *ngIf="tipificacionActual.enviarSms  && !tipificacionActual.sameSms" type="text" id="numberSms" style="outline: 1px solid black; padding: 5px;">
                        <mat-label *ngIf="tipificacionActual.enviarSms"> Texto SMS </mat-label>
                        <input *ngIf="tipificacionActual.enviarSms" type="text" id="textSms" style="width:90%; outline: 1px solid black; padding: 5px;">
                        <br><br><br>
                        <div class="atBottom">
                            <button mat-raised-button (click)="doActivarSms()" class="cta-button" style="margin-left: 10px;"  color="accent">
                              Actualizar Opciones
                            </button>
                            <button mat-raised-button (click)="muestraOpcionesSms = false; muestraTipificaciones = true;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                              Cerrar
                            </button>
                        </div>
            </mat-card-content>
            
          </mat-card>
        </div>

        <div *ngIf="muestraTipificaciones" class="flexContainer">
            <mat-card class="leadForm" style="width: 60%;">
                <mat-card-header>
                <mat-card-title-group>
                  <mat-card-title>Tipificaciones</mat-card-title>
                  <mat-card-subtitle>Clasificación</mat-card-subtitle>
                </mat-card-title-group>
              </mat-card-header>
              <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
                <mat-label>Tipificaciones actuales</mat-label>
                <mat-list style="width: 400px; height: 150px; overflow-y: scroll;">
                  <mat-list-item *ngFor="let tip of tipificaciones()">
                    <p>{{tip.tipificacion}}
                      <span style="float: right;">
                        <i class="material-icons" [ngStyle]="{'color': tip.enviarSms ? 'lime' : 'gray'}" style="cursor: pointer;" (click)="activarSms(tip)">sms</i>
                        <i class="material-icons" [ngStyle]="{'color': tip.enviarEmail ? 'lime' : 'gray'}" style="cursor: pointer;" (click)="activarEmail(tip)">email</i>
                        <i class="material-icons" style="cursor: pointer;" (click)="borrarTipificacion(tip)">delete</i>
                      </span>
                    </p>
                  </mat-list-item>
                </mat-list>
                <mat-form-field appearance="outline" style="margin-right: 20px; width: 80%;">
                  <mat-label>Añadir</mat-label>
                  <input matInput id="tipificacion" style="width: 200%;">
                  <mat-icon matSuffix class="secondary-text">business_center</mat-icon>
               </mat-form-field>
                 
                        <div class="atBottom">
                              <button mat-raised-button (click)="makeTipificaciones()" class="cta-button" style="margin-left: 10px;"  color="accent">
                                Crear Tipificación
                              </button>
                              <button mat-raised-button (click)="muestraTipificaciones = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                                Cerrar
                              </button>
                      </div>
              </mat-card-content>
              
            </mat-card>
        </div>

        <div *ngIf="muestraObjetivos" class="flexContainer">
          <mat-card class="leadForm" style="width: 80%;">
              <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>Resultados</mat-card-title>
                <mat-card-subtitle>Objetivos</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
              <mat-label>Objetivos actuales</mat-label>
              <mat-list style="height: 150px; overflow-y: scroll;">
                <mat-list-item *ngFor="let obj of objetivos()">
                  <p>{{obj}}<span style="float: right;"><i class="material-icons" style="cursor: pointer;" (click)="borrarObjetivo(obj)">delete</i></span></p></mat-list-item>
              </mat-list>
              <mat-form-field appearance="outline" style="margin-right: 20px; width: 80%;">
                <mat-label>Añadir</mat-label>
                <input id="objetivo" matInput>
                <mat-icon matSuffix class="secondary-text">business_center</mat-icon>
             </mat-form-field>
               
                      <div class="atBottom">
                            <button mat-raised-button (click)="makeObjetivos()" class="cta-button" style="margin-left: 10px;"  color="accent">
                              Crear Objetivo
                            </button>
                            <button mat-raised-button (click)="muestraObjetivos = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                              Cerrar
                            </button>
                    </div>
            </mat-card-content>
            
          </mat-card>
      </div>

      <div *ngIf="muestraEmail" class="flexContainer">
        <mat-card class="leadForm" style="width: 60%;">
            <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>Envios</mat-card-title>
              <mat-card-subtitle>Configurar Email</mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
                    <mat-label>Email</mat-label>
                    <mat-form-field appearance="outline" style="margin-right: 20px; width: 80%;">
                      <input id="email" matInput>
                      <mat-icon matSuffix class="secondary-text">business_center</mat-icon>
                    </mat-form-field>
                      
                    <div class="atBottom">
                      <input type="checkbox" id="checkEmail" style="margin-right: 10px;">
                      <mat-label>Activar comunicación por email</mat-label>
                      <br><br>
                          <button mat-raised-button (click)="makeEmail()" class="cta-button" style="margin-left: 10px;"  color="accent">
                            Aceptar
                          </button>
                          <button mat-raised-button (click)="muestraEmail = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                            Cerrar
                          </button>
                  </div>
          </mat-card-content>
          
        </mat-card>
      </div>

      <div *ngIf="muestraSms" class="flexContainer">
        <mat-card class="leadForm" style="width: 60%;">
            <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>Envios</mat-card-title>
              <mat-card-subtitle>Configurar Sms</mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content class="flexContainer" style="flex-direction: column; height: auto;">
                    <mat-label>Sms</mat-label>
                    <mat-form-field appearance="outline" style="margin-right: 20px; width: 80%;">
                      <input id="sms" matInput>
                      <mat-icon matSuffix class="secondary-text">business_center</mat-icon>
                    </mat-form-field>
                      
                    <div class="atBottom">
                      <input type="checkbox" id="checkSms" style="margin-right: 10px;">
                      <mat-label>Activar comunicación por Sms</mat-label>
                      <br><br>
                          <button mat-raised-button (click)="makeSms()" class="cta-button" style="margin-left: 10px;"  color="accent">
                            Aceptar
                          </button>
                          <button mat-raised-button (click)="muestraSms = false;" class="cta-button" style="margin-left: 10px; background-color: whitesmoke; color: black;" color="accent">
                            Cerrar
                          </button>
                  </div>
          </mat-card-content>
          
        </mat-card>
      </div>

      <div *ngIf="loading" class="fuse-navy">
        <div class="center">
          <div class="spinner-wrapper">
              <div class="spinner">
                  <div class="inner">
                      <div class="gap"></div>
                      <div class="left">
                          <div class="half-circle"></div>
                      </div>
                      <div class="right">
                          <div class="half-circle"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
               
    </div>
        
    <!-- ///////////////////////////////////////-->
        
